import { render, staticRenderFns } from "./FormDateField.vue?vue&type=template&id=473df403&scoped=true"
import script from "./FormDateField.vue?vue&type=script&lang=js"
export * from "./FormDateField.vue?vue&type=script&lang=js"
import style0 from "./FormDateField.vue?vue&type=style&index=0&id=473df403&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473df403",
  null
  
)

export default component.exports